import {onFind} from "@elements/init-modules-in-scope";
import Modal from 'bootstrap/js/dist/modal';

export function init () {
    onFind(".js-product-success-modal", function (modal) {
       let productModal = modal;
       productModal = new Modal(productModal);
       productModal.show();
    });
}